import { QuestionnaireDraft } from '@digital-twins/shared-types'

/**
 * Where an issue's path points. A commit-gate issue (a Save's 422
 * `operation_result_invalid`, any accepted-state refusal) names its field in
 * the bundle, as `draft.<path>`; a validator issue names it in the draft.
 */
export function getValidationTarget(
  draft: QuestionnaireDraft,
  issuePath: string,
): {
  step: 'audience' | 'workspace' | 'assets' | 'review'
  questionId?: string
  /** The asset card an indexed `testedAssets.assets[N]` path names. */
  assetId?: string
} {
  const path = issuePath.startsWith('draft.')
    ? issuePath.slice('draft.'.length)
    : issuePath
  if (path.startsWith('audience.')) {
    return { step: 'audience' }
  }
  const assetMatch = path.match(/^testedAssets\.assets\[(\d+)\]/)
  if (assetMatch) {
    const asset = draft.testedAssets?.assets?.[Number(assetMatch[1])]
    return { step: 'assets', ...(asset?.id ? { assetId: asset.id } : {}) }
  }
  if (path.startsWith('testedAssets.') || path.startsWith('assets[')) {
    return { step: 'assets' }
  }

  const researchQuestionMatch = path.match(/^researchQuestions(?:\[(\d+)\])?/)
  if (researchQuestionMatch) {
    const indexGroup = researchQuestionMatch[1]
    if (indexGroup === undefined) {
      return { step: 'workspace' }
    }
    const index = Number(indexGroup)
    const question = Number.isFinite(index)
      ? draft.researchQuestions[index]
      : null
    return {
      step: 'workspace',
      questionId: question?.id,
    }
  }

  return { step: 'review' }
}
